<template>
  <div class="notfound-page">
    <div class="notfound-card">
      <router-link to="/" class="notfound-logo" aria-label="Ir a Neliel Papelería">
        <img src="https://neliel.mx/img/logo_neliel.png" alt="Neliel Papelería" />
      </router-link>

      <div class="notfound-code" aria-hidden="true">404</div>
      <h1 class="notfound-title">Página no <em>encontrada</em></h1>
      <p class="notfound-desc">
        La dirección que buscas no existe o cambió de lugar.
      </p>
      <p class="notfound-path" v-if="ruta">
        <i class="fas fa-link"></i> {{ ruta }}
      </p>

      <div class="notfound-actions">
        <router-link to="/" class="btn btn-primary">
          <i class="fas fa-home"></i> Ir al inicio
        </router-link>
        <router-link :to="{ path: '/', hash: '#contacto' }" class="btn btn-ghost">
          <i class="fas fa-envelope"></i> Contáctanos
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  computed: {
    ruta() {
      return this.$route.fullPath
    },
  },
  mounted() {
    // Una URL inexistente no debe indexarse
    this.robotsMeta = document.createElement('meta')
    this.robotsMeta.name = 'robots'
    this.robotsMeta.content = 'noindex'
    document.head.appendChild(this.robotsMeta)

    this.tituloPrevio = document.title
    document.title = 'Página no encontrada · Neliel Papelería'
  },
  beforeUnmount() {
    if (this.robotsMeta) this.robotsMeta.remove()
    document.title = this.tituloPrevio
  },
}
</script>

<style scoped>
.notfound-page {
  min-height: 100vh;
  display: flex; align-items: center; justify-content: center;
  padding: 40px 16px;
  background: var(--c-bg);
  font-family: var(--f-body);
  position: relative;
  overflow: hidden;
}
/* Círculos decorativos con los colores de marca, como el hero de Home */
.notfound-page::before,
.notfound-page::after {
  content: '';
  position: absolute; border-radius: 50%;
  pointer-events: none;
}
.notfound-page::before {
  width: 50vw; height: 50vw; top: -15vw; right: -15vw;
  background: radial-gradient(circle, rgba(240,194,178,0.5) 0%, transparent 70%);
}
.notfound-page::after {
  width: 36vw; height: 36vw; bottom: -12vw; left: -12vw;
  background: radial-gradient(circle, rgba(246,223,164,0.45) 0%, transparent 70%);
}

.notfound-card {
  position: relative; z-index: 1;
  background: var(--c-surface);
  border: 1px solid var(--c-border);
  border-radius: var(--r-xl);
  box-shadow: var(--sh-lg);
  padding: 40px 36px;
  max-width: 480px; width: 100%;
  text-align: center;
}

/* Espacio libre alrededor del logo (manual de marca) */
.notfound-logo { display: inline-block; padding: 8px; margin-bottom: 8px; }
.notfound-logo img { height: 72px; width: auto; display: block; }

.notfound-code {
  font-size: clamp(4rem, 14vw, 6rem);
  font-weight: 700;
  line-height: 1;
  color: var(--c-primary);
  letter-spacing: -0.02em;
  margin-bottom: 8px;
}

.notfound-title {
  font-family: var(--f-body);
  font-size: clamp(1.4rem, 4vw, 1.8rem);
  font-weight: 700;
  color: var(--c-primary);
  margin: 0 0 10px;
}
/* Tipografía secundaria (caligráfica) solo en textos cortos */
.notfound-title em {
  font-family: 'Dancing Script', cursive;
  font-style: normal;
  color: var(--c-coral);
}

.notfound-desc {
  font-size: 0.95rem; color: var(--c-text3);
  line-height: 1.6; margin: 0 0 16px;
}

.notfound-path {
  display: inline-flex; align-items: center; gap: 8px;
  max-width: 100%;
  font-size: 0.8rem; color: var(--c-text2);
  background: var(--c-overlay);
  border: 1px dashed var(--c-border-s);
  border-radius: 999px;
  padding: 6px 14px; margin: 0 0 24px;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.notfound-path i { color: var(--c-coral); flex-shrink: 0; }

.notfound-actions {
  display: flex; gap: 12px; justify-content: center; flex-wrap: wrap;
}

@media (max-width: 640px) {
  .notfound-card { padding: 32px 20px; }
  .notfound-logo img { height: 56px; }
  .notfound-actions .btn { width: 100%; justify-content: center; }
}
</style>
